// グローバルメニューとヘッダ通知ベルは全ページに描かれるので、ラベル／通知本文が引く
// 辞書 namespace はページごとの dicts ではなく全ページで読む。
//
// resolveMenuItemLabel や NotificationListItem（resolveInputFormMessage）は dict_key があると
// d() の結果をそのまま返し、引けなくても label へは戻らない。d() は custom || master || key
// なので、namespace を載せていないページではサイドバーやベルに
// "purchase_request:resource.purchase_requests" や "purchase_receipt:notification.ordered_title"
// のようなキー文字列がそのまま出る（エラーにならないので気づけない）。
//
// common は withPageAuthRequired が必ず足すので、ここには common 以外だけを並べる。
// メニューに common 以外の namespace の dict_key を足したら、ここにも足すこと
// （GlobalHeaderMenus.test.ts が両者の一致を見ている）。
export const GLOBAL_MENU_DICT_NAMESPACES = ["purchase_request", "purchase_receipt"];

// ヘッダ通知ベルだけが引く namespace。メニューに無いものは GLOBAL_MENU_DICT_NAMESPACES ではなくここに足す。
// v2 が dict キーで通知を作る namespace もここに追加する。
export const GLOBAL_NOTIFICATION_DICT_NAMESPACES = ["group_data_share"];

// ページが指定した dicts に、common とメニュー用・通知用 namespace を足したもの。
export const buildPageDictNamespaces = (dicts?: string[]): string[] =>
  Array.from(new Set([...(dicts ?? []), "common", ...GLOBAL_MENU_DICT_NAMESPACES, ...GLOBAL_NOTIFICATION_DICT_NAMESPACES]));
